import React from "react";
import { Tooltip } from "react-tippy";

function TooltipComponent({
  title = "",
  position = "top",
  trigger = "mouseenter focus",
  delay = 400,
  animation = "shift",
  arrow = true,
  theme = "transparent",
  hideOnClick = true,
  touchHold = true,
  children,
  ...props
}) {
  return (
    <>
      <Tooltip
        title={title}
        position={position}
        trigger={trigger}
        delay={delay}
        animation={animation}
        arrow={arrow}
        theme={theme}
        hideOnClick={hideOnClick}
        touchHold={touchHold}
        {...props}
      >
        {children}
      </Tooltip>
    </>
  );
}

export { TooltipComponent };
